import React, { useEffect } from 'react';
import { CanceledError } from 'axios';

import Conditional from '../../../common/conditional';

import GeneralAnomalyRecommendation from './generalAnomalyRecommendation';
import PCNLAnomalyRecommendation from './pcnlAnomalyRecommendation';

import { ItemWithAnomaly, PCNLItemModel, Project } from '../../../../utils/models';
import { ExportParams } from '../../../blocks/pdf-export';
import { base64Upload } from '../../../../services/fileUpload';
import { uploadProjectUrl } from '../../../../services/reportService';

import config from '../../../../utils/config';

interface AnomalyRecommendationProps {
    projectDetails: Project;
    items: ItemWithAnomaly[];
    exportParams: ExportParams;
    title?: string;
    showSummarySection?: boolean;
}

const AnomalyRecommendation: React.FC<AnomalyRecommendationProps> = ({ exportParams, projectDetails, items, showSummarySection = true, title = 'Anomaly & Recommendation' }) => {
    useEffect(() => {
        const controller = new AbortController();

        const saveProjectUrl = async () => {
            try {
                const base64 = await exportParams.getBase64String();
                if (!base64) return;

                const url = await base64Upload(projectDetails.documentNumber + '_Anomaly_Summary', base64);
                if (url) await uploadProjectUrl(projectDetails._id, url, controller.signal);
            } catch (error) {
                if (error instanceof CanceledError) return;
            }
        };

        const timeout = setTimeout(() => {
            saveProjectUrl();
        }, 3_000);

        return () => {
            clearTimeout(timeout);
            controller.abort();
        }

		// eslint-disable-next-line
    }, [projectDetails._id]);

    return ( 
       <>
            <Conditional isVisible={projectDetails.inspectionTypeId !== config.supportedTemplates.pcnlStructuralIntegrityReport}>
               <GeneralAnomalyRecommendation 
                    projectDetails={projectDetails}
                    items={items as PCNLItemModel[]}
                    exportParams={exportParams}
                    title={title}
                    showSummarySection={showSummarySection}
                />
            </Conditional>
            
            <Conditional isVisible={projectDetails.inspectionTypeId === config.supportedTemplates.pcnlStructuralIntegrityReport}>
                <PCNLAnomalyRecommendation
                    projectDetails={projectDetails}
                    items={items as PCNLItemModel[]}
                    exportParams={exportParams}
                    title={title}
                />
            </Conditional>
       </>
    );
};

export default AnomalyRecommendation;